// app/[locale]/(client)/payment-success/page.tsx
"use client";

import { useEffect, useState } from "react";
import { useLocale, useTranslations } from "next-intl";
import { countrySlugMap } from "@/lib/localizedRoutes/localizedCountries";
import PaymentSuccessComponent from "@/components/payment/payment-component";
import { newListingSubRoutes } from "@/lib/localizedRoutes/localizedRoutes";
import { useParams, useSearchParams } from "next/navigation";
import { makeLocalizedHrefNoLocale } from "@/lib/localizedRoutes/routeHelpers";

export default function ClientPaymentSuccessPage() {
  const locale = useLocale();
  const t = useTranslations("PaymentSuccess");
  const params = useParams(); // Gets the [status] folder name
  const searchParams = useSearchParams();
  const status = params.status as string;
  const listingId = searchParams.get("listingId");
  const [redirectUrl, setRedirectUrl] = useState("/");
  const subRoute =
    newListingSubRoutes.publish[
      locale as keyof typeof newListingSubRoutes.publish
    ];
  const retryUrl = listingId
    ? `/${locale}${makeLocalizedHrefNoLocale(locale, "new-listing", [subRoute, listingId])}`
    : undefined;

  useEffect(() => {
    const preferredCountry = sessionStorage.getItem("preferredCountry");
    if (preferredCountry && countrySlugMap[preferredCountry]) {
      const slug = countrySlugMap[preferredCountry][locale];
      setRedirectUrl(`/${slug}`);
    }
  }, [locale]);

  return (
    <PaymentSuccessComponent
      status={status}
      redirectUrl={redirectUrl}
      redirectLabel={t("goHome")}
      retryUrl={retryUrl}
    />
  );
}
